exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.programDialog.v-dialog {\r\n  overflow-y: inherit;\n}\r\n", ""]);

// exports
